import Vue from 'vue';
import Vuetify, {VApp, VContainer, VFlex, VImg, VLayout} from 'vuetify/lib';

Vue.use(Vuetify, {
  components: {VApp, VFlex, VLayout, VContainer, VImg},
  icons: {
    iconfont: 'mdi',
  }
});

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#005AAB',
        error: '#EE2B2A',
        success: '#18A460',
        warning: '#FFB700'
      }
    }
  }
});
